import {useEffect, useRef} from 'react';
import css from './onboard.module.scss';
import {OnboardProps} from './onboard.types';

export const Onboard = (props: OnboardProps): JSX.Element => {
	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const height = ref.current?.clientHeight as number;
		props.onHeightSet(height);
	});

	return (
		<div className={css.container}>
			<div className={css.shadow} />
			<div ref={ref} className={css.content}>
				{props.children}
			</div>
		</div>
	);
};
